import config from '../../../config';
import ValidationService from '../../../lib/validation';

const validatePostCode = values => {
  if (!config.inferAddressStateOrProvinceFromPostCode) {
    return null;
  }

  return {
    postCode: ValidationService.validatePostCode(values.postCode),
  };
};

const validate = values => ({
  fullName: ValidationService.validateBillingAddressField(values.fullName),
  houseNumber: ValidationService.validateBillingAddressField(
    values.houseNumber,
    {
      maxLength: 30,
      presenceNotRequired: true,
    },
  ),
  street1: ValidationService.validateBillingAddressField(values.street1, {
    maxLength: 38,
  }),
  street2: ValidationService.validateBillingAddressField(values.street2, {
    maxLength: 38,
    presenceNotRequired: true,
  }),
  ...validatePostCode(values),
  city: ValidationService.validateBillingAddressField(values.city),
  stateOrProvince: ValidationService.validateBillingAddressField(
    values.stateOrProvince,
  ),
});

export default validate;
